import React from 'react';
import { Flex, Button, Form, Input, message, Checkbox } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';
// import PWAInstall from '../../components/pwa-install'
import { sendUserLoginToApp, detectWebView, openUrlExternally } from '../../utils/jsbridge';

const { isWebView } = detectWebView();

const Login = (props) => {
    const [loginForm] = Form.useForm();

    React.useEffect(() => {
        sendUserLoginToApp({});
    }, []);
    const onSubmit = async () => {
        console.log("所有字段值：", loginForm.getFieldsValue());  // 调试信息
        console.log("单独获取agree值：", loginForm.getFieldValue('agree'));  // 调试信息
        const data = await loginForm.validateFields();

        console.log("验证后的数据：", data);  // 调试信息

        // document.getElementById('loginForm').submit();
        let response = await fetch('/api/auth/virify', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });

        let result = await response.json();

        if(result && result.success) {
            
            const { accStatus, accId, userId } = result.data;
            // 获取URL returnUrl参数
            const url = new URL(window.location.href);
            let returnUrl = url.searchParams.get('return_url');
            // 仅当returnUrl是绝对URL（包含协议）且为http时，替换为https
            if (returnUrl) {
                returnUrl = decodeURIComponent(returnUrl);
                // 检查是否为绝对URL（包含协议）
                if (returnUrl.startsWith('http://')) {
                    returnUrl = returnUrl.replace('http://', 'https://');
                }
            } else {
                returnUrl = '/index'; // 保持原始逻辑
            }
            
            // 通过JS Bridge通知APP登录成功，并传递用户信息
            sendUserLoginToApp({
                userId: userId,
            });
            
            switch (accStatus) {
                case 0:
                    window.location.href = `/regist2?accId=${accId}`;
                    break;
                case 1:
                    setTimeout(() => {
                        window.location.href = '/waiting';
                    }, 500);
                    break;
                case 2:
                    setTimeout(() => {
                        window.location.href = returnUrl;
                    }, 500);
                    break;
                default:
                    setTimeout(() => {
                        window.location.href = returnUrl;
                    }, 500);
                    break;
            }
        } else {
            message.error('登录失败');
        }
    };

    return (
        <div className='flex flex-col safe-top safe-bottom min-h-[calc(100vh-120px)]'>
            {/* <PWAInstall /> */}
            
            {/* 主内容区 - 垂直居中 */}
            <div className="flex-1 flex items-center justify-center">
                <Form
                    form={loginForm}
                    id='loginForm'
                    name="basic"
                    action="/login"
                    method='post'
                    className="w-full max-w-md bg-white shadow-xl rounded-2xl p-5 md:p-8 select-none"
                    autoComplete="off"
                >
                    {/* Logo 和标题区域 */}
                    <Flex gap={5} align='center' wrap className="mb-6 md:mb-8"> 
                        <h3 className="text-xl md:text-2xl font-bold text-gray-800 m-0">优选到家管理系统</h3>
                        <a 
                            className="text-gray-500 hover:text-blue-600 transition-colors min-h-touch min-w-touch flex items-center justify-center" 
                            onClick={() => openUrlExternally('https://www.yxdj.tech/')}
                        >
                            <QuestionCircleOutlined className="text-lg" />
                        </a>
                    </Flex>

                    {/* 表单区域 */}
                    <div className="space-y-4">
                        <Form.Item
                            label=""
                            name="phoneNo"
                            rules={[
                                {
                                    required: true,
                                    message: '请输入手机号',
                                },
                            ]}
                            className="mb-0"
                        >
                            <Input 
                                placeholder='手机号' 
                                className="rounded-lg min-h-touch text-base" 
                                size="large"
                                type="tel"
                                autoComplete="tel"
                            />
                        </Form.Item>

                        <Form.Item
                            label=""
                            name="password"
                            rules={[
                                {
                                    required: true,
                                    message: '请输入密码!',
                                },
                            ]}
                            className="mb-0"
                        >
                            <Input 
                                placeholder='请输入密码' 
                                type='password' 
                                className="rounded-lg min-h-touch text-base" 
                                size="large"
                                autoComplete="current-password"
                            />
                        </Form.Item>

                        <Form.Item
                            label=""
                            name='agree'
                            valuePropName="checked"
                            rules={[
                                {
                                    validator: (_, value) =>
                                        value ? Promise.resolve() : Promise.reject(new Error('请阅读用户隐私协议和账户使用协议并同意'))
                                }
                            ]}
                            className="mb-0"
                        >
                            <Checkbox id='agree' className="text-sm text-gray-600 min-h-touch flex items-center">
                                <span>已阅读并同意</span>
                                <a href='https://www.yxdj.tech/privacy-policy.html' className="text-blue-600 hover:text-blue-800 mx-1 active:opacity-70 transition-opacity">隐私政策</a>
                                <span>和</span>
                                <a href='https://www.yxdj.tech/account-usage-agreement.html' className="text-blue-600 hover:text-blue-800 mx-1 active:opacity-70 transition-opacity">账户使用协议</a>
                            </Checkbox>
                        </Form.Item>
                    </div>

                    {/* 按钮区域 */}
                    <div className="flex gap-3 mt-6 mb-4">
                        <Button 
                            href='/regist' 
                            type='default' 
                            className="flex-1 rounded-lg min-h-touch text-base font-medium bg-white hover:bg-gray-50 active:scale-95 transition-transform border-gray-300"
                            size="large"
                        >
                            注册
                        </Button>
                        <Button 
                            type='primary' 
                            onClick={onSubmit} 
                            htmlType="submit" 
                            className="flex-1 rounded-lg min-h-touch text-base font-medium bg-blue-600 hover:bg-blue-700 border-blue-600 active:scale-95 transition-transform"
                            size="large"
                        >
                            登录
                        </Button>
                    </div>

                    {/* 辅助链接 */}
                    <Flex className="mt-4 text-sm" align='center' justify='space-between' gap={2}>
                        <a 
                            onClick={() => openUrlExternally('https://www.yxdj.tech/')} 
                            className="text-gray-600 hover:text-blue-600 transition-colors min-h-touch flex items-center active:opacity-70"
                        >
                            <QuestionCircleOutlined className="mr-1" /> 了解优选到家
                        </a>
                        <a 
                            href='/forget' 
                            className="text-gray-600 hover:text-blue-600 transition-colors min-h-touch flex items-center active:opacity-70"
                        >
                            忘记密码？
                        </a>
                    </Flex>
                </Form>
            </div>

            {/* 底部版权信息 */}
            <p className="px-4 py-3 text-center text-xs text-gray-500 safe-bottom">
                ©{new Date().getFullYear()}{' '}
                <a 
                    onClick={() => openUrlExternally('https://www.yxdj.tech/')} 
                    className="hover:text-blue-600 transition-colors active:opacity-70"
                >
                    杭州优选到家科技有限公司
                </a>{' '}
                版权所有<br />
                浙ICP备2025162413号-3
            </p>
        </div>
    )
}

export default Login;